//没配置南京白名单，剔除
const dealNanJingWhite = (data) => {
  const purchaseAreaTreeVo = data;
  const authIdArr = [12730, 20212];//生产：20212；uat：12730
  purchaseAreaTreeVo.childList.forEach(item => {
    if (Number(item.authId) === 12226) {//销售业务
      item.childList.forEach((childItem, index) => {
        if (authIdArr.includes(Number(childItem.authId))) {//原材料订单管理 剔除
          item.childList.splice(index, 1);
        }
      })
    }
  });
  return purchaseAreaTreeVo;
}
//易专采没配置南京白名单，剔除
const isPurchaseDealNanJingWhite = (data) => {
  let menuData = data;
  const nanJingWhiteArr = [12726, 20208,];
  menuData.childList.forEach((item, index) => {
    if (nanJingWhiteArr.includes(Number(item.authId))) {
      menuData.childList.splice(index, 1);
    }
  })
  return menuData;
}


export default {
  dealNanJingWhite,
  isPurchaseDealNanJingWhite
}